// extracted by mini-css-extract-plugin
module.exports = {"Header":"DynamicPopup_Header__2qJhK","Icon":"DynamicPopup_Icon__1LZyv","Close":"DynamicPopup_Close__30HRU"};